import {Component, OnDestroy, OnInit} from '@angular/core';
import {NgbProgressbarConfig} from '@ng-bootstrap/ng-bootstrap/progressbar/progressbar-config';
import { HistoryCreditsDialogComponent } from '../history-credits-dialog/history-credits-dialog.component';
import { MdDialog, MdDialogRef } from '@angular/material';
import { JobOffersService } from '../../services/job-offers.service';
import {Subscription} from "rxjs";
import { PaymentDialogComponent } from '../payment-dialog/payment-dialog.component';
import {PaymentService} from '../../services/payment.service';

@Component({
  selector: 'app-dashboard-mycredits',
  templateUrl: './dashboard-mycredits.component.html',
  styleUrls: ['./dashboard-mycredits.component.css']
})

export class DashboardMycreditsComponent implements OnInit, OnDestroy {

  constructor(
    public dialog: MdDialog,
    private jobService: JobOffersService,
    public paymentService: PaymentService
  ) { }

  errorMessage: string;
  value: number = 0;
  plan = 0;
  s: Subscription;
  type: number;
  transactions: any;
  totalTransactionsUsed: number;
  totalTransactions: number;
  loading: boolean;
  page: number = 1;
  total: number = 0;
  max: number = 10;

  ngOnInit() {
    this.searchTransactions();
    this.searchTransactionsUsed();
    this.type = Number(localStorage.getItem('type'));
    this.getOffers();
  }

  getOffers() {
    //TODO: waiting for proper endpoint
    let status = [];
    status.push (1);
    status.push (-1);
    status.push (-2);
    status.push (-6);
    this.s = this.jobService.getOffers(undefined, undefined, status, 1, 1)
      .subscribe(
        offers => {
          this.value = offers.pagination.total;
        },
        error => this.errorMessage = <any>error
      );
  }

  ngOnDestroy() {
    this.s.unsubscribe();
  }

  openDialogHistoryCredits() {
      let dialogRef = this.dialog.open(HistoryCreditsDialogComponent);
  }

  openDialogPaymentCredits() {
    let dialogRef = this.dialog.open(PaymentDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      this.searchTransactions();
      this.searchTransactionsUsed();
    });
  }

  searchTransactionsUsed (page?: number, query?: string, active?: boolean, deleted?: boolean) {
    this.loading = true;

    this.page = page;
    if (page == null) {
      page = 1;
    }

    const status =0;
    this.totalTransactionsUsed = 0;
    this.paymentService.getTransaction(page, this.max, status)
    .subscribe(
    data => {
      this.totalTransactionsUsed = data.pagination.total;
      this.loading = false;
    },
    error => {
      if (error.status == 404) {
        this.transactions = undefined;
        this.totalTransactionsUsed = 0;
        this.loading = false;
      } else {
        console.log(error);
        this.transactions = undefined;
        this.total = 0;
        this.totalTransactionsUsed = 0;
        this.loading = false;
      }
    });
  }

  searchTransactions (page?: number, query?: string, active?: boolean, deleted?: boolean) {
    this.loading = true;

    this.page = page;
    if (page == null) {
      page = 1;
    }

    this.paymentService.getTransaction(page, this.max)
    .subscribe(
    data => {
      this.totalTransactions = data.pagination.total;
      this.loading = false;
    },
    error => {
      if (error.status == 404) {
        this.transactions = undefined;
        this.totalTransactions = 0;
        this.loading = false;
      } else {
        console.log(error);
        this.transactions = undefined;
        this.totalTransactions = 0;
        this.loading = false;
      }
    });
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/dashboard-mycredits/dashboard-mycredits.component.ts